let formContactUsValidator = null;
let lang;

const formContactUsInitValidator = function() {
    if (formContactUsValidator == null) {
        if ($('#form-contactus').length) {
            lang = 'EN';
        } else if ($('#form-contactus-es').length) {
            lang = 'ES';
        }

        if ('EN' == lang) {
            formContactUsValidator = $('#form-contactus').validate({
                rules: {
                    contactus_name: {
                        required: true
                    },
                    contactus_email: {
                        required: true,
                        email: true
                    },
                    contactus_phone: {
                        required: true
                    },
                    contactus_comments: {
                        required: true
                    }
                },
                messages: {
                    contactus_name: {
                        required: 'Write your name, please'
                    },
                    contactus_email: {
                        required: 'Write your email, please',
                        email: 'The email is not correct'
                    },
                    contactus_phone: {
                        required: 'Write your phone number, please'
                    },
                    contactus_comments: {
                        required: 'Write your message, please'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formContactUsValidator = $('#form-contactus-es').validate({
                rules: {
                    contactus_name: {
                        required: true
                    },
                    contactus_email: {
                        required: true,
                        email: true
                    },
                    contactus_phone: {
                        required: true
                    },
                    contactus_comments: {
                        required: true
                    }
                },
                messages: {
                    contactus_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    contactus_email: {
                        required: 'Escriba su email, por favor',
                        email: 'El email no es correcto'
                    },
                    contactus_phone: {
                        required: 'Escriba su número de teléfono, por favor'
                    },
                    contactus_comments: {
                        required: 'Escriba sus comentarios, por favor'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};
const formContactUsSend = function() {
    $('#contactus-success').addClass('d-none');
    $('#contactus-error').addClass('d-none');
    formContactUsInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-contactus').valid()) {
            return false;
        }
        url = '/api/formulario/send';
    } else if ('ES' == lang) {
        if (!$('#form-contactus-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/send';
    }
    $('#btn-contactus-send').addClass('d-none');
    $('#btn-contactus-sending').removeClass('d-none');
    const payload = {
        name: $('#contactus_name').val(),
        email: $('#contactus_email').val(),
        phone: $('#contactus_phone').val(),
        comments: $('#contactus_comments').val(),
        subject: 'Helicópteros Sanitarios: formulario "contact us"'
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-contactus-send').removeClass('d-none');
            $('#btn-contactus-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#contactus_name,#contactus_email,#contactus_phone,#contactus_comments').val('');
                //$('#contactus-success').html(data.message).removeClass('d-none');
                if ('EN' == lang) {
                    document.location.href = './thanks.html';
                } else if ('ES' == lang) {
                    document.location.href = './gracias.html';
                }
            } else {
                $('#contactus-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-contactus-send').removeClass('d-none');
            $('#btn-contactus-sending').addClass('d-none');
            if ('EN' == lang)
                $('#contactus-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#contactus-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formContactUsSend = formContactUsSend;